export default "__VITE_ASSET__4fedfee4__"